import React from 'react';
import { Tooltip } from '@mui/material';
import { lookupTerm } from '../../constants/glossary';

// Wraps a piece of jargon with a dotted underline and a tap/hover tooltip
// pulled from the shared glossary (constants/glossary.js), so a term is
// defined once and reused everywhere it appears instead of assuming the
// reader already knows it or leaving it unexplained.
//
// Usage: <GlossaryTerm term="PAT">GitHub PAT</GlossaryTerm>
// If `term` has no glossary entry, renders children unchanged (no dotted
// underline) so an unlisted term never silently looks interactive.
const GlossaryTerm = ({ term, children }) => {
  const definition = lookupTerm(term);
  if (!definition) return <>{children}</>;

  return (
    <Tooltip title={definition} arrow enterTouchDelay={0} leaveTouchDelay={4000}>
      <span
        style={{
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          textUnderlineOffset: '3px',
          cursor: 'help',
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};

export default GlossaryTerm;
